import React from 'react';
import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import {
  Banner,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { TrashIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';

import messages from './messages';

const DeleteContractModal = ({ open, onClose, onConfirm, intl }) => {
  // No `variant` on either action: Modal resolves it as
  // `variant ?? children === 'Cancel' ? 'text' : 'primary'`, which parses so that any explicit
  // variant collapses to 'text'. Omitting it gives Cancel a text button and Confirm a primary one.
  const actionsProps = [
    {
      children: intl.formatMessage(messages.cancel),
      onClick: onClose,
    },
    {
      children: intl.formatMessage(messages.confirm),
      onClick: onConfirm,
      submitButton: true,
    },
  ];

  return (
    <Modal
      open={open}
      title={intl.formatMessage(messages.title)}
      onClose={onClose}
      icon={<TrashIcon />}
      status={'warning'}
      actionsProps={actionsProps}
    >
      <Typography
        variant={'bodyMedium'}
        color={'text.secondary'}
        marginBottom={1.5}
        display={'block'}
      >
        {intl.formatMessage(messages.confirmationText)}
      </Typography>
      <Banner
        status={'warning'}
        message={intl.formatMessage(messages.warningBanner)}
      />
    </Modal>
  );
};

export default DeleteContractModal;
